<template>
  <a-dropdown
    v-if="currentUser && currentUser.nickname"
    class="ant-pro-dropdown ant-pro-dropdown-action"
    placement="bottomRight"
    overlayClassName="pro-components-header-dropdown-index-container"
  >
    <span>
      <!--      <a-avatar size="small" :src="currentUser.avatar" class="ant-pro-header-account-avatar" />-->
      <span class="ant-pro-header-account-name anticon" style="color: #1890ff">
        {{ currentUser.nickname }}
      </span>
    </span>
    <template v-slot:overlay>
      <a-menu class="ant-pro-dropdown-menu" :selected-keys="[]">
        <!--        <a-menu-item v-if="menu && is_super_user" key="settings" @click="handleToModel">-->
        <!--          <setting-outlined />-->
        <!--          运维登录-->
        <!--        </a-menu-item>-->
        <a-menu-divider v-if="menu" />
        <a-menu-item v-if="menu" key="settings1" @click="handleChangePassword">
          <setting-outlined />
          修改密码
        </a-menu-item>
        <a-menu-item v-if="menu && is_super_user" key="settings2" @click="handleChangeUser">
          <setting-outlined />
          切换用户
        </a-menu-item>
        <a-menu-item key="settings3" @click="handleChangeOrg">
          <setting-outlined />
          修改组织名称
        </a-menu-item>
        <a-menu-divider v-if="menu" />
        <a-menu-item key="logout" @click="handleLogout">
          <logout-outlined />
          退出登录
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
  <span v-else>
    <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
  </span>

  <form-modal
    v-bind="editModal"
    v-if="editModal.visible"
    @cancel="
      () => {
        editModal.visible = false;
      }
    "
    @ok="handlerOk"
  />
  <switch-user-modal
    v-bind="changeUserModal"
    v-if="changeUserModal.visible"
    @ok="handlerSwitchOk"
    @cancel="
      () => {
        changeUserModal.visible = false;
      }
    "
  />
</template>

<script lang="ts">
import { createVNode, defineComponent, reactive, ref } from 'vue';
import {
  UserOutlined,
  SettingOutlined,
  LogoutOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import {
  CHECK_IS_SUPER_USER,
  GET_INFO,
  GET_SHOP,
  LOGIN_YUN_WEI,
  LOGOUT,
} from '@/store/modules/user/actions';
import FormModal from '@/components/form-modal/form-modal.vue';
import SwitchUserModal from '@/components/switch-user-modal.vue';
import { message, Modal, notification } from 'ant-design-vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import { change_password } from '@/api/sys/';
import modalBox from '@/components/form-modal/modal-tools';
import { update_organization } from '@/api/permission/user-manage';

export default defineComponent({
  name: 'AvatarDropdown',
  props: {
    currentUser: {
      type: Object,
      default: () => null,
    },
    menu: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n();
    const current_org = store.getters['user/current_org'];
    const is_super_user = ref(false);

    const edit_model_config = {
      settings: {
        name: '表单名称',
        labelAlign: 'right',
        layout: 'horizontal',
      },
      fields: [
        {
          type: 'input',
          name: 'username',
          label: '账号',
          disabled: false,
          allowClear: true,
          inputType: 'text',
          maxlength: 100,
          defaultValue: '',
          placeholder: '请填写角色名称',
        },
        {
          type: 'input',
          name: 'password',
          label: '密码',
          disabled: false,
          allowClear: true,
          inputType: 'text',
          defaultValue: '',
          placeholder: '请填写角色描述',
        },
      ],
      rules: {
        username: [{ required: true, message: '账号必须填写' }],
        password: [{ required: true, message: '密码必须填写' }],
      },
      model: {
        username: '',
        password: '',
      },
    };

    const editModal = reactive({
      visible: false,
      title: '运维登录',
      form: edit_model_config,
      options: {},
    });
    const changeUserModal = reactive({
      visible: false,
      title: '切换用户',
    });
    const handleLogout = () => {
      store.dispatch(`user/${LOGOUT}`).then(() => {
        router.push({ path: '/user/login' });
      });
    };
    const handleToModel = () => {
      editModal.visible = true;
    };
    const handleChangeUser = () => {
      changeUserModal.visible = true;
    };

    const handleChangeOrg = () => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '修改组织名称',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
          },
          fields: [
            {
              type: 'input',
              name: 'name',
              label: '名称',
              disabled: false,
              allowClear: true,
              defaultValue: '',
              placeholder: '请填写名称',
            },
          ],
          rules: { name: [{ required: true, message: '请填入名称' }] },
          model: {
            org_id: current_org?.id,
            name: current_org?.name,
            short_name: current_org?.short_name ? current_org?.short_name : current_org?.name,
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(function (resolve) {
            editModal.loading = true;
            update_organization({
              ...payload,
              org_id: current_org?.id,
              aim_org_id: current_org?.id,
            })
              .then((res: any) => {
                Modal.confirm({
                  title: '重新登录才能看到效果?',
                  icon: createVNode(ExclamationCircleOutlined),
                  onOk() {
                    return new Promise(resolve => {
                      store.dispatch(`user/${LOGOUT}`).then(() => {
                        router.push({ path: '/user/login' });
                      });
                      resolve(null);
                    }).catch(() => console.log('Oops errors!'));
                  },
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onCancel() {},
                });
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    };

    const handlerOk = (data: any) => {
      // e.preventDefault();
      store
        .dispatch(`user/${LOGIN_YUN_WEI}`, {
          ...data,
          org_id: current_org.id,
        })
        .then(() => {
          message.success('登录运维成功');
          editModal.visible = false;
        });
    };
    const handlerSwitchOk = () => {
      changeUserModal.visible = false;
      message.success('切换用户成功');
      // store.dispatch(`user/${GET_INFO}`).then(()=>{
      // store
      //   .dispatch(`user/${GET_SHOP}`, { org_id: Number(ls.get(STORAGE_CURRENT_ORG_KEY).id) })
      //   .then(() => {
      location.href = '/';
      // location.reload();
      // });
      // });
    };
    const handleChangePassword = () => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '修改密码',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
          },
          fields: [
            {
              type: 'password',
              name: 'oldpassword',
              label: '旧密码',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'password',
              name: 'newpassword',
              label: '新密码',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'password',
              name: 'newpassword2',
              label: '确认密码',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
          ],
          rules: {
            oldpassword: [{ required: true, message: '请输入旧密码' }],
            newpassword: [{ required: true, message: '请输入新密码' }],
          },
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            oldpassword: null,
            newpassword: null,
            newpassword2: null,
          }),
        },
        options: {},
        ok: (payload: any) => {
          if (payload.newpassword !== payload.newpassword2) {
            notification.error({
              message: '输入数值错误',
              description: '两次输入密码不一致',
            });
            return false;
          }
          return new Promise(resolve => {
            editModal.loading = true;
            change_password(payload)
              .then(() => {
                message.success('修改密码成功');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    };

    store
      .dispatch(`user/${CHECK_IS_SUPER_USER}`, {
        org_id: current_org?.id,
      })
      .then(() => {
        is_super_user.value = store.getters['user/is_super_user'];
      });
    return {
      t,
      editModal,
      changeUserModal,
      handlerSwitchOk,
      is_super_user,
      router,

      handleChangeUser,
      handleChangeOrg,
      handleLogout,
      handleToModel,
      handlerOk,
      handleChangePassword,
    };
  },
  components: {
    UserOutlined,
    SettingOutlined,
    LogoutOutlined,
    FormModal,
    SwitchUserModal,
  },
});
</script>

<style lang="less">
@import './header-dropdown.less';

.ant-pro-header-account-name {
  vertical-align: unset;
}

.ant-pro-header-account-avatar {
  margin: 12px 8px 12px 0;
  color: @primary-color;
  vertical-align: top;
  background: hsla(0, 0%, 100%, 0.85);
}
</style>
